import type { AdminSupportActionQueueRow } from "@/types/admin-support";

/**
 * Support actions queue — mirrors `SUPPORT_ACTIONS_QUEUE` in
 * design_handoff_zone_admin/data-ops.jsx
 */
export const MOCK_SUPPORT_ACTIONS_QUEUE: AdminSupportActionQueueRow[] = [
  {
    queueId: "SA-3211",
    userId: "usr_Ng2WoSfErT",
    displayName: "Aiyana Whitehorse",
    email: "aiyana.whitehorse@example.com",
    actionType: "account_deletion",
    severity: "warn",
    source: "in-app · Settings → Delete account",
    state: "pending",
    reason: "Within 30d return window — refund + hardware return required",
    policy: "Refund $348 + reclaim within 7d delete",
    requestedLabel: "12m ago",
  },
  {
    queueId: "SA-3208",
    userId: "usr_Yb9CkS2oFx",
    displayName: "Brigit Lindqvist",
    email: "brigit.lindqvist@example.com",
    actionType: "account_deletion",
    severity: "crit",
    source: "support email",
    state: "blocked",
    reason: "Account suspended — fraud cluster",
    policy: "Trust & Safety review required",
    requestedLabel: "3h ago",
  },
  {
    queueId: "SA-3205",
    userId: "usr_Z7xK1bGqYf",
    displayName: "Daniel Achterberg",
    email: "daniel.achterberg@example.com",
    actionType: "data_export",
    severity: "ok",
    source: "my.wear.zone",
    state: "processing",
    reason: "GDPR Article 15 — JSON + CSV bundle",
    policy: "Deliver within 30d (target: 48h)",
    requestedLabel: "1h ago",
  },
  {
    queueId: "SA-3201",
    userId: "usr_8K2nP9XmRq",
    displayName: "Pari Patel",
    email: "pari.patel@example.com",
    actionType: "data_export",
    severity: "ok",
    source: "in-app",
    state: "ready",
    reason: "User-initiated export · 142MB",
    policy: "Download link valid 7d",
    requestedLabel: "8h ago",
  },
  {
    queueId: "SA-3198",
    userId: "usr_Vp1ZuJ5hNw",
    displayName: "Hilda Okafor",
    email: "hilda.okafor@example.com",
    actionType: "force_signout",
    severity: "crit",
    source: "Trust & Safety",
    state: "completed",
    reason: "Suspended fraud review",
    policy: "All 4 refresh tokens revoked",
    requestedLabel: "5h ago",
  },
  {
    queueId: "SA-3194",
    userId: "usr_Ks2VqB4rTy",
    displayName: "Konrad Strachan",
    email: "konrad.strachan@example.com",
    actionType: "force_password_reset",
    severity: "ok",
    source: "user-initiated",
    state: "completed",
    reason: "Standard reset link, used within 12min",
    policy: "Token expires in 15min",
    requestedLabel: "1d ago",
  },
  {
    queueId: "SA-3190",
    userId: "usr_Mr3OdBnRtY",
    displayName: "Theresa Goldfarb",
    email: "theresa.goldfarb@example.com",
    actionType: "force_password_reset",
    severity: "warn",
    source: "support-initiated by kai.ramirez@",
    state: "completed",
    reason: "User locked out after 8 failed attempts",
    policy: "1-hour progressive lockout cleared",
    requestedLabel: "2d ago",
  },
  {
    queueId: "SA-3187",
    userId: "usr_Wp5JxQzLbH",
    displayName: "Anh-Tu Nguyen",
    email: "anh-tu.nguyen@example.com",
    actionType: "lock_account",
    severity: "warn",
    source: "automatic",
    state: "auto_unlocked",
    reason: "10 failed login attempts in 1h",
    policy: "24h progressive lockout — auto-released",
    requestedLabel: "3d ago",
  },
];
